import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
import FourOhFour from '@/views/FourOhFour'
import Login from '@/views/Login'
import Dashboard from '@/views/Dashboard'
import Product from '@/views/product/Product'
import ParentProduct from '@/views/product/ParentProduct'
import PrintProduct from '@/views/product/PrintProduct'
import EditProduct from '@/views/product/EditProduct'
import SalesLog from '@/views/sales/SalesLog'
import AddSales from '@/views/sales/AddSales'
import EditSales from '@/views/sales/EditSales'
import Inbound from '@/views/inbound/Inbound'
import AddInbound from '@/views/inbound/AddInbound'
import AddInboundItem from '@/views/inbound/AddInboundItem'
import EditInbound from '@/views/inbound/EditInbound'
import Packing from '@/views/packing/Packing'
import Shipping from '@/views/shipping/Shipping'
import SalesReport from '@/views/report/SalesReport'
import DailyReport from '@/views/report/DailyReport'
import StockMovement from '@/views/report/StockMovement'
import GeoReport from '@/views/report/GeoReport'
import Customer from '@/views/customer/Customer'
import Partners from '@/views/customer/partners/Partners'
import AddPartner from '@/views/customer/partners/AddPartner'
import ChangePassword from '@/views/setting/ChangePassword'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/product/print',
      name: 'Print Product',
      component: PrintProduct,
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem('token')) {
          next()
        } else {
          next('/login')
        }
      }
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem('token')) {
          next()
        } else {
          next('/login')
        }
      },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'sales',
          name: 'Sales Log',
          component: SalesLog
        },
        {
          path: 'sales/add',
          name: 'Add Sales Log',
          component: AddSales,
          beforeEnter: (to, from, next) => {
            var account = JSON.parse(localStorage.getItem('account'))
            if (account.role.toUpperCase() === 'FINANCE' || account.role.toUpperCase() === 'MANAGER' || account.role.toUpperCase() === 'CS') {
              next()
            } else {
              next(false)
            }
          }
        },
        {
          path: 'sales/edit/:uid',
          name: 'Edit Sales Log',
          component: EditSales,
          beforeEnter: (to, from, next) => {
            var account = JSON.parse(localStorage.getItem('account'))
            if (account.role.toUpperCase() === 'FINANCE' || account.role.toUpperCase() === 'MANAGER' || account.role.toUpperCase() === 'CS') {
              next()
            } else {
              next(false)
            }
          }
        },
        {
          path: 'product/list',
          name: 'Product List',
          component: Product
        },
        {
          path: 'product/parent',
          name: 'Product Parent',
          component: ParentProduct
        },
        {
          path: 'product/edit/:uid',
          name: 'Edit Product',
          component: EditProduct,
          beforeEnter: (to, from, next) => {
            var account = JSON.parse(localStorage.getItem('account'))
            if (account.role.toUpperCase() === 'FINANCE' || account.role.toUpperCase() === 'MANAGER' || account.role.toUpperCase() === 'WAREHOUSE') {
              next()
            } else {
              next(false)
            }
          }
        },
        {
          path: 'inventory/inbound',
          name: 'Inbound List',
          component: Inbound
        },
        {
          path: 'inventory/inbound/add',
          name: 'Add Inbound',
          component: AddInbound,
          beforeEnter: (to, from, next) => {
            var account = JSON.parse(localStorage.getItem('account'))
            if (account.role.toUpperCase() === 'FINANCE' || account.role.toUpperCase() === 'MANAGER' || account.role.toUpperCase() === 'WAREHOUSE') {
              next()
            } else {
              next(false)
            }
          }
        },
        {
          path: 'inventory/inbound/edit/:uid',
          name: 'Edit Inbound',
          component: EditInbound,
          beforeEnter: (to, from, next) => {
            var account = JSON.parse(localStorage.getItem('account'))
            if (account.role.toUpperCase() === 'FINANCE' || account.role.toUpperCase() === 'MANAGER' || account.role.toUpperCase() === 'WAREHOUSE') {
              next()
            } else {
              next(false)
            }
          }
        },
        {
          path: 'inventory/inbound/item/add/:uid',
          name: 'Add Inbound Item',
          component: AddInboundItem,
          beforeEnter: (to, from, next) => {
            var account = JSON.parse(localStorage.getItem('account'))
            if (account.role.toUpperCase() === 'FINANCE' || account.role.toUpperCase() === 'MANAGER' || account.role.toUpperCase() === 'WAREHOUSE') {
              next()
            } else {
              next(false)
            }
          }
        },
        {
          path: 'inventory/packing/:uid',
          name: 'Packing',
          component: Packing,
          beforeEnter: (to, from, next) => {
            var account = JSON.parse(localStorage.getItem('account'))
            if (account.role.toUpperCase() === 'FINANCE' || account.role.toUpperCase() === 'MANAGER' || account.role.toUpperCase() === 'WAREHOUSE') {
              next()
            } else {
              next(false)
            }
          }
        },
        {
          path: 'inventory/shipping/:uid',
          name: 'Shipping',
          component: Shipping,
          beforeEnter: (to, from, next) => {
            var account = JSON.parse(localStorage.getItem('account'))
            if (account.role.toUpperCase() === 'FINANCE' || account.role.toUpperCase() === 'MANAGER' || account.role.toUpperCase() === 'WAREHOUSE') {
              next()
            } else {
              next(false)
            }
          }
        },
        {
          path: 'customer/partners',
          name: 'Partner List',
          component: Partners
        },
        {
          path: 'customer/partners/add',
          name: 'Add Partner',
          component: AddPartner
        },
        {
          path: 'customer/list',
          name: 'Customer List',
          component: Customer
        },
        {
          path: 'report/sales',
          name: 'Sales Report',
          component: SalesReport
        },
        {
          path: 'report/daily',
          name: 'Daily Report',
          component: DailyReport
        },
        {
          path: 'report/stock',
          name: 'Stock Movement',
          component: StockMovement
        },
        {
          path: 'report/geo',
          name: 'Geographical Report',
          component: GeoReport
        },
        {
          path: 'profile/password',
          name: 'Setting Password',
          component: ChangePassword
        }
      ]
    },
    {
      path: '**',
      name: 'Four Oh Four',
      component: FourOhFour
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js